import apiResource from '@/services/http/api/resource';

const defaultState = () => {
    return {
        provinces: [],
        currentProvinceName: null,
        currentProvinceId: null,
        allFamiliesAmount: null,
        familiesHelpedAmount: null,
        loader: null
    };
};

export default {
    namespaced: true,
    state: defaultState(),
    getters: {
        getProvinces: state => state.provinces,
        getLoader: state => state.loader,
        getCurrentProvinceName: state => state.currentProvinceName,
        getCurrentProvinceId: state => state.currentProvinceId,
        getFamiliesAmount: state => state.allFamiliesAmount,
        getFamiliesHelpedAmount: state => state.familiesHelpedAmount
    },
    mutations: {
        setProvinces (state, payload) {
            state.provinces = payload;
        },
        setCurrentProvinceName (state, payload) {
            state.currentProvinceName = payload;
        },
        setCurrentProvinceId (state, payload) {
            state.currentProvinceId = payload;
        },
        setFamiliesAmount (state, payload) {
            state.allFamiliesAmount = payload;
        },
        setFamiliesHelpedAmount (state, payload) {
            state.familiesHelpedAmount = payload;
        },
        setLoader (state, payload) {
            state.loader = payload;
        },
        clear (state) {
            state.provinces = defaultState().provinces;
            state.loader = defaultState().loader;
            state.currentProvinceName = defaultState().currentProvinceName;
            state.allFamiliesAmount = defaultState().allFamiliesAmount;
            state.familiesHelpedAmount = defaultState().familiesHelpedAmount;
        }
    },
    actions: {
        getProvinces (context) {
            context.commit('setLoader', true);

            apiResource.getProvinces().then(({ data }) => {
                context.commit('setProvinces', data.data);
                return data.data;
            }).catch(() => {

            }).finally(() => {
                context.commit('setLoader', false);
            });
        },
        getFamiliesAmount (context) {
            return apiResource.getFamiliesAmount().then(({ data }) => {
                context.commit('setFamiliesAmount', data.data.waiting);
                context.commit('setFamiliesHelpedAmount', data.data.helped);
            });
        }
    }
};
